
import React, { useEffect, useRef } from 'react';
import Prism from 'prismjs';
import 'prismjs/components/prism-bash';

interface TerminalProps {
  commands: { input: string; output?: string }[];
}

const Terminal: React.FC<TerminalProps> = ({ commands }) => {
  const terminalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (terminalRef.current) {
      const codeElements = terminalRef.current.querySelectorAll('code');
      codeElements.forEach(element => {
        Prism.highlightElement(element);
      });
    }
  }, [commands]);

  return (
    <div className="terminal-window" ref={terminalRef}>
      <div className="terminal-header">
        <span className="terminal-dot red"></span>
        <span className="terminal-dot yellow"></span>
        <span className="terminal-dot green"></span>
        <span className="terminal-title">Terminal</span>
      </div>
      <div className="terminal-content">
        {commands.map((cmd, i) => (
          <div key={i} className="terminal-line">
            <div className="terminal-prompt">
              <span className="terminal-prompt-user">user</span>
              <span className="terminal-prompt-separator">@</span>
              <span className="terminal-prompt-host">abra</span>
              <span className="terminal-prompt-location">:~$</span>
            </div>
            <div className="terminal-command">
              <code className="language-bash">{cmd.input}</code>
            </div>
            {cmd.output && (
              <div className="terminal-output">
                <pre>
                  <code className="language-bash">
                    {cmd.output}
                  </code>
                </pre>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Terminal;